<div class="login-screen" *ngIf="isLoad">
    <div class="wrapper-reponsive">
        <div class="content-box mt-3 mb-3">
            <div class="logo-login">
                <img src="../../../../assets/img/smarttohmas.png" alt="">
            </div>
            <div class="row-input row-input-auto-height mb-4">
                <div class="pl-3">
                    <div class="tlt-dot mb-1">{{'STR_EMAIL_ADDRESS' | translate}}</div>
                    <input (keydown)="RemoveErr(1)" (keyup)="toLowerCase()"  [ngClass]="{'error-border': isEmail }" type="text" [(ngModel)]="maillAdress" maxlength="254" class="form-control mb-3" autocomplete="false">
                    <div *ngIf="isEmail" class="err-validate">
                        <span>{{messErr | translate}}</span>
                    </div>
                    <div class="tlt-dot mb-1">{{'STR_PASSWORD'| translate}}</div>
                    <input (keydown)="RemoveErr(2)" autocomplete="new-password" id="passLogin" [(ngModel)]="password" (paste)="onPaste($event)" [ngClass]="{'error-border': isPass }"  type="password" class="form-control mb-3">
                    <div *ngIf="isPass" class="err-validate">
                        <span>{{messErr2 | translate}}</span>
                    </div>
                    <a [href]="url" (click)="resetPass()">
                        <strong>{{'STR_LINK_RESET_PASSWORD'| translate }}</strong>
                    </a>
                </div>
            </div>
            <div class="pl-4 mb-4">
                <div class="pl-3">
                    <label class="custom-checkbox">
                        {{'STR_KEEP_LOGIN'| translate }}
                        <input type="checkbox" [(ngModel)]="isCheck">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <div class="text-center">
                <div class="mb-3">
                    <button class="btn btn-common btn-bg-green" (click)="Login()">
                        {{'STR_BTN_LOGIN'| translate }}
                    </button>
                </div>
                <div>
                    <button class="btn btn-common btn-bg-yellow"  (click)="regis()">
                        {{'STR_REGISTRATION_NEW'| translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
